import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Re-usable page header / "interior hero" used on each sub-page so the user
 * gets a clear sense of where they are in the multi-page site.
 */
export const PageHero = ({ eyebrow, title, accent, subtitle, bg, breadcrumb }) => (
  <section
    data-testid="page-hero"
    className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden"
  >
    {bg && (
      <>
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${bg}')` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]/60" />
      </>
    )}
    {!bg && <div className="absolute inset-0 bg-[#0A0A0A]" />}
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#E60000]" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <nav className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-5 flex items-center gap-2 font-bold">
        <Link to="/" className="hover:text-[#E60000]">Home</Link>
        <span>/</span>
        <span className="text-[#E60000]">{breadcrumb}</span>
      </nav>
      {eyebrow && (
        <div className="text-xs uppercase tracking-widest text-[#E60000] font-bold mb-3">{eyebrow}</div>
      )}
      <h1 className="font-heading text-6xl sm:text-7xl md:text-8xl text-white leading-none mb-4">
        {title} {accent && <span className="text-[#E60000]">{accent}</span>}
      </h1>
      {subtitle && (
        <p className="text-base sm:text-lg text-white/70 max-w-2xl leading-relaxed">{subtitle}</p>
      )}
    </div>
  </section>
);

export const SectionCTA = ({ to, label, sublabel }) => (
  <Link
    to={to}
    data-testid={`cta-${to.replace(/\//g, "")}`}
    className="group inline-flex items-center gap-3 bg-[#E60000] hover:bg-[#FF3333] text-white px-6 h-12 uppercase tracking-widest font-bold text-sm border-2 border-transparent hover:border-white transition-colors"
  >
    {label}
    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={3} />
    {sublabel && <span className="opacity-70 text-xs normal-case tracking-normal">{sublabel}</span>}
  </Link>
);
